import type { ClarifyingQuestion } from "@/hooks/use-stream-conversation";

export type Answer = {
    type: "choice" | "other" | "skipped";
    value?: string;
};

/**
 * Formats the answers into a markdown-structured message to send to the agent.
 */
export function formatClarifyingQuestionsResponse(
    questions: ClarifyingQuestion[],
    answers: Map<string, Answer>,
): string {
    const lines: string[] = [];
    for (const question of questions) {
        const answer = answers.get(question.questionId);
        if (!answer || answer.type === "skipped") {
            lines.push(`**${question.question}**  \n[skipped]`);
        } else {
            lines.push(`**${question.question}**  \n${answer.value}`);
        }
    }
    return lines.join("\n\n");
}
